module.exports = __webpack_public_path__ + "8298c501508c5febd1c6d898110df1e1.jpg";